import {
  CylinderGeometry,
  ShaderMaterial,
  Mesh,
  Color,
  Group,
  RingGeometry,
  MeshBasicMaterial,
  DoubleSide,
} from 'three';
import { COLORS, PLATFORM } from '../constants';
import energyFieldVert from '../shaders/energy-field.vert?raw';
import energyFieldFrag from '../shaders/energy-field.frag?raw';

export class PlatformRenderer {
  readonly group: Group;
  private material: ShaderMaterial;
  private edgeMaterial: MeshBasicMaterial;

  constructor() {
    this.group = new Group();

    // Main platform surface
    const geometry = new CylinderGeometry(
      PLATFORM.radius,
      PLATFORM.radius,
      PLATFORM.height,
      PLATFORM.segments,
      1,
      false
    );

    this.material = new ShaderMaterial({
      vertexShader: energyFieldVert,
      fragmentShader: energyFieldFrag,
      uniforms: {
        uTime: { value: 0 },
        uColor: { value: new Color(COLORS.platformGlow) },
        uPulse: { value: 0 },
      },
      transparent: true,
      depthWrite: false,
    });

    const platform = new Mesh(geometry, this.material);
    platform.position.y = -PLATFORM.height / 2;
    this.group.add(platform);

    // Edge glow ring
    const ringGeometry = new RingGeometry(
      PLATFORM.radius - 0.1,
      PLATFORM.radius + 0.05,
      PLATFORM.segments
    );
    this.edgeMaterial = new MeshBasicMaterial({
      color: COLORS.platformGlow,
      transparent: true,
      opacity: 0.3,
      side: DoubleSide,
    });
    const ring = new Mesh(ringGeometry, this.edgeMaterial);
    ring.rotation.x = -Math.PI / 2;
    ring.position.y = 0.01;
    this.group.add(ring);

    // Inner glow ring
    const innerRing = new RingGeometry(0.3, 0.6, 32);
    const innerMaterial = new MeshBasicMaterial({
      color: COLORS.healthy,
      transparent: true,
      opacity: 0.5,
    });
    const inner = new Mesh(innerRing, innerMaterial);
    inner.rotation.x = -Math.PI / 2;
    inner.position.y = 0.02;
    this.group.add(inner);
  }

  update(time: number): void {
    this.material.uniforms.uTime.value = time;
    this.material.uniforms.uPulse.value = Math.sin(time * 0.3) * 0.5;
    this.edgeMaterial.opacity = 0.2 + 0.1 * Math.sin(time * 0.8);
  }
}
